@if (config()) {
  <div class="parameter-timezone-config">
    @if (config()) {
      <mat-form-field
        class="parameter-timezone-config__field without-subscript small-form-field"
        appearance="outline"
      >
        @if (!hideLabel()) {
          <mat-label>{{ parameterTitle }}</mat-label>
        }
        <input
          #timezoneInput
          type="text"
          matInput
          [formControl]="formControl"
          [matAutocomplete]="auto"
          (keyup.enter)="selectOption()"
          [attr.data-testid]="'parameter-timezone-input'"
        />
        <mat-autocomplete
          #auto="matAutocomplete"
          (optionSelected)="onSelectionChange($event, config())"
          [displayWith]="getTimezoneName"
          #timezoneAutocomplete
        >
          @for (timezone of filteredOptions; track timezone) {
            <mat-option
              [value]="timezone"
              [attr.data-testid]="'parameter-timezone-option-' + timezone.offset"
            >
              {{ getTimezoneName(timezone) }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    }
    @if (config().parameter.description && showInfo()) {
      <div class="small-icon-button-wrapper">
        <button mat-icon-button>
          <mat-icon
            class="parameter-timezone-config__icon"
            color="primary"
            [matTooltip]="config().parameter.description"
            >info_outline
          </mat-icon>
        </button>
      </div>
    }
    @if (value() && !readonly() && hasDelete() && !disabled()) {
      <div class="small-icon-button-wrapper">
        <button mat-icon-button>
          <mat-icon
            (click)="onClickRemove()"
            class="parameter-timezone-config__close"
            color="warn"
            matTooltip="Discard changes"
            >close
          </mat-icon>
        </button>
      </div>
    }
    @if (value() && !readonly() && hasUndo() && !disabled()) {
      <div class="small-icon-button-wrapper">
        <button mat-icon-button>
          <mat-icon
            (click)="onClickUndo()"
            class="parameter-timezone-config__close"
            color="warn"
            matTooltip="Discard changes"
            >close
          </mat-icon>
        </button>
      </div>
    }
    @if (hasClose() && !disabled()) {
      <div class="small-icon-button-wrapper">
        <button mat-icon-button>
          <mat-icon (click)="onClickClose()" matTooltip="Close">close</mat-icon>
        </button>
      </div>
    }
    @if (showReset() && !disabled()) {
      <div class="small-icon-button-wrapper">
        <button mat-icon-button (click)="onResetToFactory()" [matTooltip]="resetToFactoryTooltip()">
          <mat-icon color="warn">replay</mat-icon>
        </button>
      </div>
    }
  </div>
}
